const SvgTooltip = () => (
	<svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M13 7A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z" fill="#827D85" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 1.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5ZM.25 7a6.75 6.75 0 1 1 13.5 0A6.75 6.75 0 0 1 .25 7Z"
			fill="#827D85"
		/>
		<path d="M7.75 10.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" fill="#fff" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.25 5.334a2.417 2.417 0 0 1 2.417-2.417h.584A2.499 2.499 0 0 1 8.465 7.6l-.467.26a.483.483 0 0 0-.248.421v.386h-1.5v-.386c0-.72.39-1.383 1.02-1.733l.466-.26a.999.999 0 0 0-.485-1.871h-.584a.917.917 0 0 0-.917.917h-1.5Z"
			fill="#fff"
		/>
	</svg>
)

export default SvgTooltip
